import React, { useEffect, useState } from 'react';
import { X, Loader2, Send, Copy, Check } from 'lucide-react';
import { api } from '../../context/AuthContext';

const inp = 'w-full border border-gray-200 px-3 py-2 text-sm text-[#1B3A5C] focus:outline-none focus:border-[#b8893d]';
const Lbl = ({ children }) => <span className="block mb-1 text-[10px] tracking-[0.15em] uppercase text-[#7a8a99]">{children}</span>;

const Erfolg = ({ res, onClose }) => {
  const [copied, setCopied] = useState(false);
  const copy = () => { navigator.clipboard?.writeText(res.link); setCopied(true); setTimeout(() => setCopied(false), 1500); };
  return (
    <div className="p-5 space-y-3" data-testid="akonto-link-erfolg">
      <p className="text-sm text-[#1B3A5C]">{res.mail_sent ? <>Zahlungsaufforderung an <strong>{res.email}</strong> gesendet.</> : 'Zahlungsaufforderung angelegt – E-Mail konnte nicht versendet werden. Link bitte manuell weitergeben:'}</p>
      <div className="flex gap-2">
        <input readOnly value={res.link} className={`${inp} font-mono text-[11px]`} data-testid="akonto-link-url" />
        <button type="button" onClick={copy} data-testid="akonto-link-copy" className="px-3 border border-[#1B3A5C] text-[#1B3A5C] hover:bg-[#1B3A5C] hover:text-white transition-colors">{copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}</button>
      </div>
      <div className="flex justify-end"><button type="button" onClick={onClose} data-testid="akonto-link-fertig" className="px-4 py-2 text-[11px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d] transition-colors">FERTIG</button></div>
    </div>
  );
};

export const AkontoLinkDialog = ({ mandant, akten, caseId = '', onClose, onDone, vorlage = null }) => {
  const [f, setF] = useState({ betrag: vorlage?.betrag ?? '', verwendungszweck: vorlage?.zweck || '', nachricht: '', case_id: vorlage?.case_id ?? caseId, email: mandant.email || '' });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [res, setRes] = useState(null);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const senden = async () => {
    setBusy(true); setErr('');
    try {
      const r = await api.post(`/register/mandanten/${mandant.mandanten_nr}/akonto-link`, { ...f, betrag: parseFloat(String(f.betrag).replace(',', '.')) || 0 });
      setRes(r.data); onDone?.();
    } catch (e) { setErr(e?.response?.data?.detail || 'Senden fehlgeschlagen'); }
    setBusy(false);
  };

  useEffect(() => { const esc = (e) => { if (e.key === 'Escape') onClose(); }; window.addEventListener('keydown', esc); return () => window.removeEventListener('keydown', esc); }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="akonto-link-dialog">
      <div className="bg-white w-full max-w-lg shadow-xl" role="dialog" aria-modal="true" aria-label="Akonto-Zahlungslink senden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#1B3A5C]"><Send className="w-4 h-4 text-[#b8893d]" /> Akonto-Zahlungslink senden</span>
          <button type="button" onClick={onClose} aria-label="Schließen" data-testid="akonto-link-close"><X className="w-4 h-4 text-[#7a8a99]" /></button>
        </div>
        <div className="px-5 py-2.5 bg-[#fbf7f0] border-b border-gray-100 text-xs text-[#34536b]">M-{mandant.mandanten_nr} · <strong className="text-[#1B3A5C]">{mandant.name || '—'}</strong></div>
        {res ? <Erfolg res={res} onClose={onClose} /> : (<>
          <div className="p-5 grid grid-cols-2 gap-3">
            <label className="col-span-2"><Lbl>E-Mail Empfänger</Lbl><input type="email" value={f.email} onChange={set('email')} className={inp} data-testid="akonto-link-email" /></label>
            <label><Lbl>Betrag (€)</Lbl><input inputMode="decimal" value={f.betrag} onChange={set('betrag')} placeholder="z. B. 500" className={inp} data-testid="akonto-link-betrag" /></label>
            <label><Lbl>Akte (optional)</Lbl>
              <select value={f.case_id} onChange={set('case_id')} className={inp} data-testid="akonto-link-akte">
                <option value="">Ohne Akte</option>
                {akten.map((a) => <option key={a.case_id} value={a.case_id}>{a.aktenzeichen ? `AZ ${a.aktenzeichen}` : a.rechtsgebiet}</option>)}
              </select>
            </label>
            <label className="col-span-2"><Lbl>Verwendungszweck</Lbl><input value={f.verwendungszweck} onChange={set('verwendungszweck')} placeholder="z. B. Vorschuss Klageverfahren" className={inp} data-testid="akonto-link-zweck" /></label>
            <label className="col-span-2"><Lbl>Nachricht (optional)</Lbl><textarea rows={3} value={f.nachricht} onChange={set('nachricht')} className={inp} data-testid="akonto-link-nachricht" /></label>
            {err && <p className="col-span-2 px-2 py-1 text-xs text-red-700 bg-red-50" data-testid="akonto-link-error">{err}</p>}
          </div>
          <div className="flex justify-end px-5 py-3 border-t border-gray-100">
            <button type="button" onClick={senden} disabled={busy || !f.betrag || !f.verwendungszweck.trim()} data-testid="akonto-link-senden"
              className="inline-flex items-center gap-1.5 px-4 py-2 text-[11px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d] transition-colors disabled:opacity-40">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />} ZAHLUNGSLINK SENDEN
            </button>
          </div>
        </>)}
      </div>
    </div>
  );
};
